module.exports = __webpack_public_path__ + "img/refresh.69ae63bd.svg";